import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { ListRecord } from '@/interfaces/new-license-request/new-license-request-interfaces';
import { Person } from '@/interfaces/person/index';
import { Document } from '@/interfaces/requirement';
import { DetailLicenseById, Equipments, TableType2 } from '@/interfaces/search/search.interface';
import { SearchService } from '@/services/search/search.service';
import { StoreState } from '@/store';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { normalize } from '@/utils/normalizeString';
import { ofuscate } from '@/utils/obfuscation';
import { parseISOString } from '@/utils/parseISOString';
import { EquipmentRowModified } from '@/views/main/license/extend/form/new-record/new-record.interfaces';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-modify-equipment',
  templateUrl: './modify-equipment.component.html',
  styleUrls: ['./modify-equipment.component.css'],
  animations: [
    trigger('fadeAnimationModifyDates', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ModifyEquipmentComponent implements OnInit, OnChanges {
  @Output() handleBack: EventEmitter<void> = new EventEmitter();
  @Output() refreshLicenseCards = new EventEmitter();

  @Input() showDetailLicense: boolean = false;
  @Input() detailLicense?: DetailLicenseById;
  @Input() licenseSelectedId: number = 0;

  @Input() get personData(): Person {
    return this._person;
  }
  set personData(person: Person) {
    this.driverIsEmployee = normalize(person.entity) === normalize('Employee');
    this._person = person;
  }
  private _person!: Person
  driverIsEmployee: boolean = false;

  @Input() get completeLicenseData(): CompleteLicense | undefined {
    return this._completeLicenseData;
  }

  set completeLicenseData(data: CompleteLicense | undefined) {
    this._completeLicenseData = data;
    if (data) {
      this.documentList = data.documents.map<Document>((document) => {
        const { dateEmit, dateFrom, dateUntil, documentRequirementUseTypeId, ...rest } = document;
        const out: Document = { ...rest, isMineRequired: documentRequirementUseTypeId || rest.name === '' };
        if (dateEmit) {
          out.dateEmit = parseISOString(dateEmit);
        }
        if (dateFrom) {
          out.dateFrom = parseISOString(dateFrom);
        }
        if (dateUntil) {
          out.dateUntil = parseISOString(dateUntil);
        }

        return out;
      }).filter((x) => !x.isMineRequired);
    }
  }
  private _completeLicenseData?: CompleteLicense;

  documentList: Document[] = [];

  nameAsset?: string = '';
  numberLicense?: string = '';
  restrictionDriver?: string = ''

  longNameAsseteOfLicense?: string = '';

  // activeLink:boolean = false;
  showButtonDelete: boolean = true;
  deletingEquipments: boolean[] = [];
  deletingZone: boolean[] = [];
  deletingTypeLicense: boolean[] = [];
  typeSelect: string = ''

  show0 = false;
  isMobile: boolean = false;

  showVehicles: Array<boolean> = [];

  equipmentFormStatus: boolean[] = [];

  constructor(
    private store: Store<StoreState>,
    private router: Router,
    private searchService: SearchService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.breakpointObserver.observe(['(max-width:767px)'])
      .subscribe((result) => {
        if (result.matches) {
          this.isMobile = result.matches;
          this.show0 = true;
        }
        else {
          this.isMobile = result.matches;
          this.show0 = false;
        }
      });
  }

  get menuState0() {
    return this.show0 ? 'open' : 'close';
  }

  get arrowState0() {
    return this.show0 ? 'openArrow' : 'closeArrow';
  }

  toggle() {
    this.show0 = !this.show0;
  }

  toggleVehicle(id: number) {
    this.showVehicles[id] = this.showVehicles[id] || false;
    this.showVehicles[id] = !this.showVehicles[id];
  }

  counter(num: number) {
    return new Array(num);
  }

  ngOnInit(): void {

  }

  ngOnChanges() {
    if (this.licenseSelectedId) {
      this.nameAsset = this.detailLicense?.name;
      this.numberLicense = this.detailLicense?.licenseNumber;
      this.restrictionDriver = this.detailLicense?.drivingRestriction;
    }
  }

  get shouldShowWarningMessage(): boolean {
    if (this.detailLicense?.equipments.some((equipment) => equipment.licenseTypes.length === 1 || equipment.conductionZones.length === 1)) {
      return true;
    }
    return false;
  }

  listToSelect(idEquipment: number, typeSelect: string) {
    this.detailLicense?.equipments.map(({ equipmentId }, index) => {
      if (idEquipment === equipmentId) {
        if (typeSelect === 'zone') this.deletingZone[index] = !this.deletingZone[index];
        if (typeSelect === 'typeLicense') this.deletingTypeLicense[index] = !this.deletingTypeLicense[index];
      }
    });
  }

  onDeleteEquiment(idEquipment: number) {
    const selectedEquiment = this.detailLicense?.equipments.find(({ equipmentId }) => equipmentId === idEquipment);
    if (selectedEquiment) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta información?',
        text: 'La Información será eliminada de tus registros si continúa.',
        text2: 'Presiona Volver para revisar la información.',
        acceptButtonText: 'Eliminar Información',

        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteEquipment(this.licenseSelectedId, idEquipment)
            .subscribe({
              next: (res) => {
                this.refreshLicenseCards.emit();
                const index = this.detailLicense?.equipments.findIndex((e) => e.equipmentId === idEquipment);
                this.detailLicense?.equipments.splice(<number>index, 1);
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());
                this.store.dispatch(modalShow({
                  title: 'Error',
                  text: 'Hubo un error, No se ha podido eliminar la  información seleccionada',
                  text2: 'Presiona Regresar para  Volver a  intentarlo.',
                  acceptButtonText: 'Regresar',
                  noShowButtonBack: true,
                  actionOnAccept: () => {
                  },
                }));

              },
              complete: () => {
                // segundo dispatch
                this.store.dispatch(loaderAnimationHide());
              },

            });

        },

      }));
    }
  }

  onDeleteZone(idEquipmentSelected: number, idZone: number) {
    if (idZone === undefined) return;
    const selectedEquiment = this.detailLicense?.equipments.find(({ equipmentId }) => equipmentId === idEquipmentSelected);
    const selectedZone = selectedEquiment?.conductionZones.find(({ id }) => id === idZone);
    if (selectedEquiment && selectedZone) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta información?',
        text: 'La Información será eliminada de tus registros si continúa.',
        text2: 'Presiona Volver para revisar la información.',
        acceptButtonText: 'Eliminar Información',

        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteZone(this.licenseSelectedId, idEquipmentSelected, selectedZone.id)
            .subscribe({
              next: () => {
                if (this.detailLicense) {
                  this.detailLicense.equipments.reduce<DetailLicenseById['equipments']>((equipments, equipment) => {
                    const newEquipment = equipment;
                    if (equipment.equipmentId === idEquipmentSelected) {
                      newEquipment.conductionZones = equipment.conductionZones.reduce<Equipments['conductionZones']>((conductionZones, conductionZone) => {
                        if (!(conductionZone.id === idZone)) {
                          conductionZones.push(conductionZone);
                        }
                        return conductionZones;
                      }, []);
                    }
                    equipments.push(newEquipment);
                    return equipments;
                  }, []);
                }
                this.refreshLicenseCards.emit();
                this.listToSelect(selectedEquiment.equipmentId, 'zone');
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.listToSelect(selectedEquiment.equipmentId, 'zone');
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

  onDeleteTypeLicense(idEquipmentSelected: number, typeId: number) {
    if (typeId === undefined) return;
    const selectedEquiment = this.detailLicense?.equipments.find(({ equipmentId }) => equipmentId === idEquipmentSelected);
    const selectedType = selectedEquiment?.licenseTypes.find(({ id }) => id === typeId);
    if (selectedEquiment?.equipmentId && selectedType?.id) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta información?',
        text: 'La Información será eliminada de tus registros si continúa.',
        text2: 'Presiona Volver para revisar la información.',
        acceptButtonText: 'Eliminar Información',
        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteTypeLicense(this.licenseSelectedId, selectedEquiment.equipmentId, selectedType.id)
            .subscribe({
              next: (res) => {
                if (this.detailLicense) {
                  this.detailLicense.equipments = this.detailLicense?.equipments.reduce<DetailLicenseById['equipments']>((equipments, equipment) => {
                    const newEquipment = equipment;
                    if (equipment.equipmentId === idEquipmentSelected) {
                      newEquipment.licenseTypes = equipment.licenseTypes.reduce<Equipments['licenseTypes']>((licenseTypes, licenseType) => {
                        if (!(licenseType.id === typeId)) {
                          licenseTypes.push(licenseType);
                        }
                        return licenseTypes;
                      }, []);
                    }
                    equipments.push(newEquipment);
                    return equipments;
                  }, []);
                }

                this.refreshLicenseCards.emit();
                this.listToSelect(selectedEquiment.equipmentId, 'typeLicense');
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());
              },
              complete: () => {
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

  // modal  confirmacion to do  tipo de la licencia agregarla al pop up
  onDeleteLicense(idLicenseSelected?: number) {
    if (idLicenseSelected) {
      this.licenseSelectedId = idLicenseSelected;
      this.longNameAsseteOfLicense = this.detailLicense?.name;
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres eliminar esta licencia?',
        text: 'La licencia será eliminada automáticamente si continúa en Eliminar Licencia.',
        text2: 'Presiona Volver para regresar a la pantalla anterior.',
        acceptButtonText: 'Eliminar Licencia',
        actionOnAccept: () => {
          const currentOfuscatedData = this.router.url.split('/').reverse()[1];
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteLicenseById(idLicenseSelected)
            .subscribe({
              next: (res) => {
                const ofuscatedData = ofuscate({
                  title: 'Eliminar Licencia',
                  subtitle: `La licencia ${this.longNameAsseteOfLicense} ha sido eliminada exitosamente.`,
                  messageBold: `N° registro: ${this.detailLicense?.licenseNumber || ''}`,
                  message: `Una copia de la eliminación fue enviada al
                correo electrónico ${this.personData.email}`,
                  actionButtonPath: `/search/driver/result/${currentOfuscatedData}/licenses`,
                  actionButtonText: 'Ir al perfil de conductor',
                });
                this.store.dispatch(loaderAnimationHide());
                this.router.navigateByUrl(`/search/action/result/${ofuscatedData}`);

              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {
                      const ofuscatedData = ofuscate({
                        variant: 'failure',
                        title: 'Eliminar Licencia',
                        subtitle: 'Hubo un problema y no hemos podido eliminar  La licencia. Por favor intenta de nuevo.',
                        actionButtonPath: `/search/driver/result/${currentOfuscatedData}/licenses`,
                        actionButtonText: 'Ir al perfil de conductor',
                      });
                      this.router.navigateByUrl(`/search/action/result/${ofuscatedData}`);

                    }
                  },
                });

              },
              complete: () => {
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

  onModifyEquipment(equipmentModified: EquipmentRowModified, equipmentIndex: number) {
    const idEquipment = equipmentModified.id;
    this.store.dispatch(modalShow({
      title: '¿Estás seguro de modificar el equipo?',
      text: 'Los cambios efectuados en los tipos de licencia y las zonas de conduccion no podrán deshacerse.',
      text2: 'Presiona Volver para revisar la información.',
      acceptButtonText: 'Modificar equipo',

      actionOnAccept: () => {
        this.store.dispatch(loaderAnimationShow());
        this.searchService.onModifyEquipment(this.licenseSelectedId, equipmentModified)
          .subscribe({
            next: (res) => {
              this.refreshLicenseCards.emit();
              const index = this.detailLicense!.equipments.findIndex((e) => e.equipmentId === idEquipment);

              const equipment = this.detailLicense!.equipments[index];
              equipment.equipmentBrand = equipmentModified.brand;
              equipment.equipmentModel = equipmentModified.model;
              equipment.licenseTypes = equipment.licenseTypes.filter((x) => equipmentModified.licenseTypes.includes(x.id));
              equipment.conductionZones = equipment.conductionZones.filter((x) => equipmentModified.conductionZones.includes(x.id));
              this.detailLicense!.equipments[index] = equipment;
              this.closeForm(equipmentIndex);
              this.store.dispatch(loaderAnimationHide());
            },
            error: () => {
              this.closeForm(equipmentIndex);
              this.store.dispatch(loaderAnimationHide());
              this.store.dispatch(modalShow({
                title: 'Error',
                text: 'Hubo un error, No se ha podido modificar el equipo',
                text2: 'Presiona Regresar para  Volver a  intentarlo.',
                acceptButtonText: 'Regresar',
                noShowButtonBack: true,
                actionOnAccept: () => {
                },
              }));
            }
          });
      },
    }));
  }

  onModifyDates(documentsToModify: Document[]) {
    this.store.dispatch(modalShow({
      title: '¿Estás seguro de modificar las fechas?',
      text: 'Los cambios efectuados en las fechas afectarán el vencimiento de la licencia y sus equipos.',
      text2: 'Presione Modificar para guardar los cambios o presione Volver para revisar la información',
      acceptButtonText: 'Modificar',

      actionOnAccept: () => {
        this.store.dispatch(loaderAnimationShow());
        this.searchService.onModifyDates(this.licenseSelectedId, documentsToModify)
          .subscribe({
            next: () => {
              this.refreshLicenseCards.emit();
              const documentList: Document[] = [...this.documentList];
              this.documentList = [];
              const self = this;
              setTimeout(() => {
                documentList.map((document, index) => {
                  const modifiedDocument = documentsToModify.find((x) => x.id === document.id);
                  if (modifiedDocument) {
                    documentList[index] = {
                      ...documentList[index],
                      dateEmit: modifiedDocument.dateEmit,
                      dateFrom: modifiedDocument.dateFrom,
                      dateUntil: modifiedDocument.dateUntil,
                    };
                  }
                });
                self.documentList = documentList;
                self.store.dispatch(loaderAnimationHide());
              }, 500);
            },
            error: () => {
              this.store.dispatch(loaderAnimationHide());
              this.store.dispatch(modalShow({
                title: 'Error',
                text: 'Hubo un error, No se han podido modificar las fechas',
                text2: 'Presiona Regresar para volver a  intentarlo.',
                acceptButtonText: 'Regresar',
                noShowButtonBack: true,
                actionOnAccept: () => {
                },
              }));

            },
            complete: () => {
              // segundo dispatch
              this.store.dispatch(loaderAnimationHide());
            },

          });
      },
    }));
  }

  openForm(index: number) {
    this.equipmentFormStatus[index] = true;
  }
  closeForm(index: number) {
    this.equipmentFormStatus[index] = false;
  }

  toogleForm(index: number) {
    this.equipmentFormStatus[index] = !this.equipmentFormStatus[index];
  }

  parseAsIdName(list: TableType2[]): ListRecord[] {
    return list.map((x) => ({ id: x.id, name: x.description }));
  }

  getDescription(list: TableType2[]) {
    return list.map((x) => x.description);
  }
}
